var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isStaff
    ? _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "title" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: "/" } },
                [
                  _c("el-breadcrumb-item", [_vm._v("设施运维")]),
                  _c("el-breadcrumb-item", [_vm._v("工程服务")]),
                  _c("el-breadcrumb-item", [_vm._v("技术改造")])
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
          _c("el-card", { staticClass: "box-card" }, [
            _c(
              "div",
              { staticClass: "search-container" },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "search-form",
                    attrs: {
                      inline: true,
                      model: _vm.searchForm,
                      "label-width": "100px"
                    }
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "创建日期" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "daterange",
                                    "range-separator": "-",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "value-format": "yyyy-MM-dd"
                                  },
                                  on: { change: _vm.handleDateChange },
                                  model: {
                                    value: _vm.searchForm.create_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "create_time",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.create_time"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "项目类型" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择"
                                    },
                                    model: {
                                      value: _vm.searchForm.project_type,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "project_type",
                                          $$v
                                        )
                                      },
                                      expression: "searchForm.project_type"
                                    }
                                  },
                                  _vm._l(_vm.projectTypeOptions, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "项目名称" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入项目名称" },
                                  model: {
                                    value: _vm.searchForm.project_name,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "project_name",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.project_name"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "客户名称" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请选择",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.searchForm.customer_name,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "customer_name",
                                          $$v
                                        )
                                      },
                                      expression: "searchForm.customer_name"
                                    }
                                  },
                                  _vm._l(_vm.customerOptions, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "审核状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择"
                                    },
                                    model: {
                                      value: _vm.searchForm.audit_status,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "audit_status",
                                          $$v
                                        )
                                      },
                                      expression: "searchForm.audit_status"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: "提交方案",
                                        value: "提交方案"
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "方案审核",
                                        value: "方案审核"
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "确认归档",
                                        value: "确认归档"
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "归档完成",
                                        value: "归档完成"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "创建人" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入创建人" },
                                  model: {
                                    value: _vm.searchForm.creator,
                                    callback: function($$v) {
                                      _vm.$set(_vm.searchForm, "creator", $$v)
                                    },
                                    expression: "searchForm.creator"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c(
                            "div",
                            { staticClass: "search-button" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.handleSearch }
                                },
                                [_vm._v("点击查询")]
                              ),
                              _c(
                                "el-button",
                                { on: { click: _vm.handleReset } },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "el-button",
                                { on: { click: _vm.debouncedExport } },
                                [_vm._v(_vm._s(_vm.exportButtonText))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "title-en" }, [_vm._v("技术改造")]),
          _c("el-card", { staticClass: "box-card" }, [
            _c(
              "div",
              { staticClass: "table-container" },
              [
                _c("div", { staticClass: "button-container" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.openCreateDrawer }
                        },
                        [_vm._v("创建项目")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        { on: { click: _vm.openColumnsDialog } },
                        [_vm._v("表头设置")]
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "el-drawer",
                  {
                    attrs: {
                      title: "创建项目",
                      visible: _vm.createDrawerVisible,
                      direction: "rtl",
                      size: "30%",
                      "destroy-on-close": true
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.createDrawerVisible = $event
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "createForm",
                        staticClass: "create-form",
                        attrs: {
                          model: _vm.createForm,
                          rules: _vm.createFormRules
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "项目名称", prop: "project_name" }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入项目名称" },
                              model: {
                                value: _vm.createForm.project_name,
                                callback: function($$v) {
                                  _vm.$set(_vm.createForm, "project_name", $$v)
                                },
                                expression: "createForm.project_name"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "项目类型", prop: "project_type" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择项目类型" },
                                model: {
                                  value: _vm.createForm.project_type,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.createForm,
                                      "project_type",
                                      $$v
                                    )
                                  },
                                  expression: "createForm.project_type"
                                }
                              },
                              _vm._l(_vm.projectTypeOptions, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "客户名称", prop: "customer_name" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择客户名称" },
                                on: { change: _vm.handleCustomerChange },
                                model: {
                                  value: _vm.createForm.customer_name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.createForm,
                                      "customer_name",
                                      $$v
                                    )
                                  },
                                  expression: "createForm.customer_name"
                                }
                              },
                              _vm._l(_vm.customerOptions, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            ),
                            _vm.createForm.isCustomCustomer
                              ? _c("el-input", {
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: { placeholder: "请输入客户名称" },
                                  model: {
                                    value: _vm.createForm.customer_name,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.createForm,
                                        "customer_name",
                                        $$v
                                      )
                                    },
                                    expression: "createForm.customer_name"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "审核人员", prop: "auditor" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择审核人员" },
                                model: {
                                  value: _vm.createForm.auditor,
                                  callback: function($$v) {
                                    _vm.$set(_vm.createForm, "auditor", $$v)
                                  },
                                  expression: "createForm.auditor"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "周德明", value: "周德明" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "方案负责人",
                              prop: "solution_manager"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入方案负责人" },
                              model: {
                                value: _vm.createForm.solution_manager,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.createForm,
                                    "solution_manager",
                                    $$v
                                  )
                                },
                                expression: "createForm.solution_manager"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "项目负责人",
                              prop: "project_manager"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入项目负责人" },
                              model: {
                                value: _vm.createForm.project_manager,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.createForm,
                                    "project_manager",
                                    $$v
                                  )
                                },
                                expression: "createForm.project_manager"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "项目地点",
                              prop: "project_location"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入项目地点" },
                              model: {
                                value: _vm.createForm.project_location,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.createForm,
                                    "project_location",
                                    $$v
                                  )
                                },
                                expression: "createForm.project_location"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "项目描述", prop: "project_desc" }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 4,
                                placeholder:
                                  "请按以下格式填写：\n1.需求简述；\n2.客户技术/工勘联系人及电话\n3.期望日期"
                              },
                              model: {
                                value: _vm.createForm.project_desc,
                                callback: function($$v) {
                                  _vm.$set(_vm.createForm, "project_desc", $$v)
                                },
                                expression: "createForm.project_desc"
                              }
                            }),
                            _c("div", { staticClass: "form-tip" }, [
                              _c("div", { staticClass: "tip-header" }, [
                                _c("i", { staticClass: "el-icon-info" }),
                                _c("span", [_vm._v("格式要求")])
                              ]),
                              _c("div", { staticClass: "tip-content" }, [
                                _c("div", { staticClass: "tip-item" }, [
                                  _c("span", { staticClass: "tip-number" }, [
                                    _vm._v("1.")
                                  ]),
                                  _c("span", { staticClass: "tip-text" }, [
                                    _vm._v("需求简述")
                                  ])
                                ]),
                                _c("div", { staticClass: "tip-item" }, [
                                  _c("span", { staticClass: "tip-number" }, [
                                    _vm._v("2.")
                                  ]),
                                  _c("span", { staticClass: "tip-text" }, [
                                    _vm._v("客户技术/工勘联系人及电话")
                                  ])
                                ]),
                                _c("div", { staticClass: "tip-item" }, [
                                  _c("span", { staticClass: "tip-number" }, [
                                    _vm._v("3.")
                                  ]),
                                  _c("span", { staticClass: "tip-text" }, [
                                    _vm._v("期望日期")
                                  ])
                                ])
                              ])
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "附件", prop: "attachments" } },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "upload-demo",
                                attrs: {
                                  action: "#",
                                  "http-request": _vm.handleUpload,
                                  "on-success": _vm.handleUploadSuccess,
                                  "on-preview": _vm.handlePreview,
                                  "on-remove": _vm.handleRemove,
                                  "before-remove": _vm.beforeRemove,
                                  limit: 3,
                                  "on-exceed": _vm.handleExceed,
                                  "file-list": _vm.createForm.attachments
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { size: "small", type: "primary" } },
                                  [_vm._v("点击上传")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "el-upload__tip",
                                    attrs: { slot: "tip" },
                                    slot: "tip"
                                  },
                                  [_vm._v("文件大小不超过50MB")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "drawer-footer" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                _vm.createDrawerVisible = false
                              }
                            }
                          },
                          [_vm._v("取 消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.submitCreateForm }
                          },
                          [_vm._v("确 定")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    ref: "table",
                    attrs: { data: _vm.projects, border: "", stripe: "" },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "operation",
                        label: "操作",
                        width: "70",
                        fixed: "right",
                        align: "center"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    style: {
                                      color:
                                        scope.row.auditor !== _vm.loginName
                                          ? "#C0C4CC"
                                          : "#F56C6C"
                                    },
                                    attrs: {
                                      type: "text",
                                      size: "small",
                                      disabled:
                                        scope.row.auditor !== _vm.loginName
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleDelete(scope.row)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                删除\n              "
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3918753427
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "55", align: "center" }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: "序号",
                        width: "60",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "project_name",
                        label: "项目名称",
                        width: "100"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      underline: false
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$router.push({
                                          name: "technicalReformDetail",
                                          query: { id: scope.row.id }
                                        })
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(scope.row.project_name) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3323307890
                      )
                    }),
                    _vm._l(_vm.visibleColumns, function(column, index) {
                      return _c("el-table-column", {
                        key: index,
                        attrs: {
                          prop: column.prop,
                          label: column.label,
                          width: column.width
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  column.prop === "project_type"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row[column.prop] || "-")
                                        )
                                      ])
                                    : column.prop === "remark"
                                    ? _c("span", [
                                        _c(
                                          "div",
                                          { staticClass: "remark-container" },
                                          [
                                            scope.row.isEditing
                                              ? [
                                                  _c("el-input", {
                                                    attrs: {
                                                      size: "small",
                                                      placeholder: "请输入备注"
                                                    },
                                                    on: {
                                                      blur: function($event) {
                                                        return _vm.handleRemarkUpdate(
                                                          scope.row
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: scope.row.remark,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "remark",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.remark"
                                                    }
                                                  })
                                                ]
                                              : [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.remark || "-"
                                                      )
                                                    )
                                                  ]),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "text",
                                                        size: "mini"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleEditRemark(
                                                            scope.row
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-edit"
                                                      })
                                                    ]
                                                  )
                                                ]
                                          ],
                                          2
                                        )
                                      ])
                                    : column.prop === "audit_status"
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row.operation_type ===
                                                  "submit"
                                                    ? "info"
                                                    : scope.row
                                                        .operation_type === "6"
                                                    ? "warning"
                                                    : scope.row[column.prop] ===
                                                      "待审核"
                                                    ? "info"
                                                    : scope.row[column.prop] ===
                                                      "已通过"
                                                    ? "success"
                                                    : scope.row[column.prop] ===
                                                      "已驳回"
                                                    ? "danger"
                                                    : "",
                                                size: "small"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    scope.row.audit_status ===
                                                      "submit"
                                                      ? "方案提交"
                                                      : scope.row
                                                          .audit_status === "6"
                                                      ? "更新项目"
                                                      : scope.row
                                                          .audit_status === "3"
                                                      ? "方案提交"
                                                      : scope.row[
                                                          column.prop
                                                        ] || "-"
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : [
                                        "create_time",
                                        "plan_date",
                                        "list_date",
                                        "modify_date"
                                      ].includes(column.prop)
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row[column.prop]
                                              ? _vm
                                                  .$moment(
                                                    scope.row[column.prop]
                                                  )
                                                  .format("YYYY-MM-DD")
                                              : "-"
                                          )
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row[column.prop] || "-")
                                        )
                                      ])
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    })
                  ],
                  2
                ),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: "设置显示项",
                      visible: _vm.showColumnsDialog,
                      "append-to-body": true,
                      width: "400px",
                      "close-on-click-modal": false,
                      "custom-class": "columns-dialog",
                      "modal-append-to-body": false,
                      "destroy-on-close": true
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.showColumnsDialog = $event
                      }
                    }
                  },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        staticClass: "checkbox-group",
                        model: {
                          value: _vm.selectedColumns,
                          callback: function($$v) {
                            _vm.selectedColumns = $$v
                          },
                          expression: "selectedColumns"
                        }
                      },
                      _vm._l(_vm.columns, function(column) {
                        return _c(
                          "el-checkbox",
                          {
                            key: column.prop,
                            staticClass: "checkbox-item",
                            attrs: { label: column.prop }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(column.label) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "dialog-footer",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.selectAllColumns }
                          },
                          [_vm._v("全选")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.restoreDefaultColumns }
                          },
                          [_vm._v("恢复默认")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.saveColumnsDialog }
                          },
                          [_vm._v("保存")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pagination-container" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage,
                        "page-sizes": [10, 20, 30, 50],
                        "page-size": _vm.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.total
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "确认删除",
                visible: _vm.deleteDialogVisible,
                width: "30%",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.deleteDialogVisible = $event
                }
              }
            },
            [
              _c("span", [_vm._v("确定要删除该项目吗？")]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.deleteDialogVisible = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.confirmDelete }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "empty-state" },
        [_c("el-empty", { attrs: { description: "暂无权限查看此页面" } })],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }